import React, { useEffect, useRef, useState } from "react"
import "./styles.scss"
import { BsTagsFill } from "react-icons/bs"
import { AiOutlinePlus } from "react-icons/ai"

const TagInput = ({ changeTag, optionTags = [], tags = [] }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [search, setSearch] = useState("")
  const selectedTags = typeof tags === "string" ? JSON.parse(tags) : tags

  const dropdownRef = useRef(null)
  const inputRef = useRef(null)

  const handleNewTag = () => {
    if (search.trim() && !optionTags.includes(search)) {
      changeTag(search, true)
      setSearch("")
    }
  }

  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      !inputRef.current.contains(event.target)
    ) {
      setIsDropdownOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div className="tag-input-container">
      <div
        className="tag-input-box"
        onClick={() => setIsDropdownOpen((prev) => !prev)}
        ref={inputRef}>
        <button className="tag-icon">
          <BsTagsFill />
        </button>
      </div>
      {isDropdownOpen && (
        <div className="tag-dropdown" ref={dropdownRef}>
          <div className="search-container">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Busque ou adicione uma tag"
              className="tag-input"
            />
            <button onClick={handleNewTag} className="add-tag-icon">
              <AiOutlinePlus />
            </button>
          </div>
          <ul className="tag-list">
            {optionTags
              .filter((tag) => tag?.toLowerCase().includes(search.toLowerCase()))
              .map((tag) => (
                <li
                  key={tag}
                  className={`tag-list-item ${selectedTags.includes(tag) ? "active" : ""}`}
                  onClick={() => changeTag(tag, false)}>
                  {tag}
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default TagInput

export const TagList = ({ tags, handleTagRemove }) => {
  const formatted = typeof tags === "string" ? JSON.parse(tags) : []
  return (
    <div className="plan-tag-list">
      {formatted.map((tag) => (
        <span key={tag} className="tag">
          {tag}
          <button onClick={() => handleTagRemove(tag)} className="remove-tag">
            &times;
          </button>
        </span>
      ))}
    </div>
  )
}
